module.exports = __webpack_public_path__ + "static/img/mn_LOGO1.5658a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/mn_LOGO1.png
// module id = 0QY2
// module chunks = 51